import React, { useState, useEffect } from 'react'
import Button from 'react-bootstrap/Button'
import Popup from './Popup/Popupformbootstrap'
import configData from '../../temp/config'

const DueDateSocialShareResult = (props) => {
  const [emailformdata, setEmailformdata] = useState({
    label: '',
    logo: '',
    imgalt: '',
    recaptchaseckey: '',
    recaptchasitekey: '',
    emailsubject: '',
    itemid: '',
    resturl: ''
  })
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  useEffect(() => {
    let subject = ''
    if (props.subject) {
        subject = props.fields.emailTemplate.fields.subject.value.replace('{subject}', props.subject)
    }
    let emailsubject = subject || props.fields.emailTemplate.fields.subject.value
    let emailApiEndPoint = props.fields.emailApiEndPoint.value.href && props.fields.emailApiEndPoint.value.href
    let datasourceId = props.fields.emailTemplate.id
    props.fields.socialShare.map(data => {
      if (data.template === "EmailShareItem") {
        setEmailformdata({
          label: data.fields.text,
          logo: data.fields.logo.value,
          imgalt: data.fields.logo.value,
          // recaptchaseckey:data.fields.recaptcha.fields.recaptchaSecretKey.value,
          recaptchasitekey: data.fields.recaptcha.fields.recaptchaSiteKey.value,
          emailsubject: emailsubject,
          //emailsubject:'Period Calculator',
          itemid: props.itemid,
          dataSourceId: datasourceId,
          resturl: emailApiEndPoint
        })
      }
    })
  }, [])

  const { t } = props;
  return (
    <>
      <div className="socialsharelinks">
        <Button variant="link btn-link-mail" onClick={handleShow}>
         
          {/* <i className="fa fa-envelope" aria-hidden="true"></i> */}
          <img src={`${configData.sitecoreApiHost}${emailformdata.logo.src}`} alt={emailformdata.imgalt.alt} />
          {emailformdata.label.value}
        </Button>
      </div>
      {
        show ?
          <Popup
            show={show}
            text='Click "Close Button" to hide popup'
            handleClose={handleClose}
            // recaptchaseckey={emailformdata.recaptchaseckey}
            recaptchasitekey={emailformdata.recaptchasitekey}
            emailsubject={emailformdata.emailsubject}
            itemid={emailformdata.itemid}
            datasourceid={emailformdata.dataSourceId}
            resturl={emailformdata.resturl}
            favNameShareResult={props.favNameShareResult}
          />
          : null
      }
    </>
  )
};

export default DueDateSocialShareResult;
